import React, { MouseEventHandler } from 'react';

import styles from './SecondaryButton.less';

interface SecondaryButtonProps {
  url: string;
  text: string;
  onClick?: MouseEventHandler;
  tabIndex?: number;
}

export const SecondaryButton: React.FunctionComponent<SecondaryButtonProps> = ({
  url,
  text,
  onClick,
  tabIndex,
}) => {
  return (
    <a
      className={styles.buttonLink}
      href={url}
      onClick={onClick}
      tabIndex={tabIndex}
    >
      {text}
    </a>
  );
};
